import { useEffect, useMemo, useState } from "react"
import styled from "styled-components"

import { ApiTypes, UITypes } from "types"

import { convertEditDevicesToState } from "utils/convertData"

import { useCustomerDashboard } from "../CustomerDashboardContext"
import { AddressInformation } from "./AddressInformation"
import { DeviceInformation } from "./DeviceInformation"

const DetailsContainer = styled.div<{ sidebarOpen?: boolean }>`
  margin-top: 2px;
  padding: 23px ${({ sidebarOpen }) => (sidebarOpen ? "24px" : "0")} 0 0;
  max-height: calc(100dvh - 255px);
  overflow-y: auto;
`

export const CustomerDashboardDetails = () => {
  const { devices, currentDevice, isSidebarOpen } = useCustomerDashboard()
  const [deviceValues, setDeviceValues] = useState<UITypes.Device | null>(null)
  const [originalDevice, setOriginalDevice] = useState<ApiTypes.Model.Device | null>(null)
  const [errors, setErrors] = useState<{ deviceName?: string; address1?: string }>({})

  const selectedDevice = devices[currentDevice]

  const convertedDevice = useMemo(() => {
    if (!selectedDevice) return null
    return convertEditDevicesToState([selectedDevice])[0]
  }, [selectedDevice.sn])

  useEffect(() => {
    if (convertedDevice && selectedDevice) {
      setDeviceValues(convertedDevice)
      setOriginalDevice(selectedDevice)
    }
  }, [convertedDevice, selectedDevice.sn])

  if (!selectedDevice || !deviceValues || !originalDevice) {
    return null
  }

  return (
    <DetailsContainer sidebarOpen={isSidebarOpen}>
      <AddressInformation
        deviceValues={deviceValues}
        setDeviceValues={setDeviceValues}
        originalDevice={originalDevice}
        errors={errors}
        setErrors={setErrors}
      />
      <DeviceInformation
        deviceValues={deviceValues}
        setDeviceValues={setDeviceValues}
        originalDevice={originalDevice}
        selectedDevice={selectedDevice}
        errors={errors}
        setErrors={setErrors}
      />
    </DetailsContainer>
  )
}
